
import React from 'react';
import 'react-tabs/style/react-tabs.css';
import { Accordion } from 'react-bootstrap-accordion';

const StakeFaq = (userData) => {
    return (
        <div className="main details center" style={{ marginTop: 15, maxWidth: 1000, }}>
            <div className="heading" style={{ marginBottom: 20, textAlign: "left", borderBottom: "2px solid #119f24", paddingBottom: 10 }}>
                <h2 style={{
                    fontSize: "22px",
                    fontFamily: "'Roboto', sans-serif", 
                    color: "#119f24",
                    margin: 0,
                    display: "inline-block",
                }}>
                    Frequently Asked Questions (FAQ)
                </h2>
            </div>
            <div className="flat-accordion" style={{ marginTop: 10 }}>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="What is staking?" show={false}  >
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            Staking is a process where you lock your tokens in a staking pool to support network operations and earn rewards.
                            <br />
                            It allows you to grow your holdings while contributing to the ecosystem.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="How do I stake?" show={false}>
                        <div
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                            }}
                        >
                            <p style={{ color: "black" }}>
                                To stake, follow these steps:
                            </p>
                            <ol
                                style={{
                                    paddingLeft: "20px",
                                    margin: "10px 0",
                                    listStyleType: "decimal",
                                    fontSize: "16px",
                                    textAlign: "left",
                                    color: "black"
                                }}
                            >
                                <li style={{ marginBottom: "8px" }}>1. Connect your wallet.</li>
                                <li style={{ marginBottom: "8px" }}>2. Enter the amount you want to stake.</li>
                                <li style={{ marginBottom: "8px" }}>3. Confirm the transaction.</li>
                                <li>Your tokens will be staked, and you'll start earning rewards immediately.</li>
                            </ol>
                        </div>
                    </Accordion>
                </div>

                <div style={{ marginBottom: 30 }}>
                    <Accordion title="What is the lock period?" show={false} >
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            The lock period for staking is 10 days. During this period, you can claim your rewards anytime.
                            <br />
                            However, unstaking your tokens will only be available after the 10-day lock period ends.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="How are staking rewards calculated?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            Rewards are calculated based on the staking rate (APY) and distributed continuously.
                            <br />
                            The longer you stake, the higher your earnings.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="Is there a minimum staking amount?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            Yes, the minimum staking amount is 20 OSCAR.
                            <br />
                            Ensure you have sufficient tokens in your wallet before attempting to stake.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="What is a referral bonus?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            If you refer someone to the platform using your unique referral link, you'll earn a bonus of 10% of their staked amount.
                            <br />
                            This bonus is credited to your account instantly and can be claimed anytime.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="How do I claim my rewards?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            Rewards can be claimed at any time by clicking the "Claim Rewards" button on the staking dashboard.
                            <br />
                            Claimed rewards will be transferred to your wallet instantly.
                        </p>
                    </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                    <Accordion title="What are the fees for staking?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            which is required to enable secure and efficient participation while discouraging misuse of the referral bonus system.

                        </p>
                    </Accordion>
                </div>

                <div style={{ marginBottom: 30 }}>
                    <Accordion title="Is my staked amount safe?" show={false}>
                        <p
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "16px",
                                lineHeight: "1.8",
                                textAlign: "left",
                                color: "black"
                            }}
                        >
                            Yes, your staked tokens are securely locked in a smart contract.
                            <br />
                            The contract is audited to ensure the safety of your funds.
                        </p>
                    </Accordion>
                </div>
            </div>
        </div>

    )
}

export default StakeFaq;
